
export const SERVICE_MAP = "ServiceMap";
export const SHUTTLE_GEOLOCATION = "ShuttleGeolocation";
export const FLEET = "Fleet";